import { Pass } from 'postprocessing'
import Material from './Material.js'

export default class GlitchPass extends Pass
{
    constructor(_options = {})
    {
        super('Dummy')

        this.material = new Material()
        this.material.uniforms.tGradient.value = _options.gradient

        this.material.uniforms.uTime.value = 0

        this.material.uniforms.uTileProgressVertical.value = - 0.5
        this.material.uniforms.uTileProgressHorizontal.value = - 0.5
        this.material.uniforms.uTileAmplitude.value = 1
        this.material.uniforms.uTileOffset.value.set(0.1, 0.03)
        this.material.uniforms.uTileFrequency.value.set(12, 20)

        this.material.uniforms.uWaveProgress.value = 0.5
        this.material.uniforms.uWaveAmplitude.value = 0.5
        this.material.uniforms.uWaveStrength.value.set(0.1, 0.0)

        this.material.uniforms.uGradientProgress.value = 1
        this.material.uniforms.uGradientOffset.value = 0.5
        this.material.uniforms.uGradientAmplitude.value = 0.5

        this.material.uniforms.uBlueProgress.value = 1
        this.material.uniforms.uBlueAmplitude.value = 0.5

        this.material.uniforms.uSaturation.value = 1

        this.material.uniforms.uWhiteTileChances.value = 0.05
        this.material.uniforms.uWhiteTileFrequency.value = 0.00015
        this.material.uniforms.uWhiteTileStrength.value = 0.0
    }

    render(renderer, inputBuffer, outputBuffer, delta, stencilTest)
    {
        this.material.uniforms.tDiffuse.value = inputBuffer.texture
        renderer.render(this.scene, this.camera, this.renderToScreen ? null : outputBuffer)
    }

    setSize(width, height)
    {
    }
}



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/Passes/GlitchPass/index.js